// Video examples configuration - separate from PERSONAS
// Each persona can have multiple example videos for the VideoExamplesSection

export const VIDEO_EXAMPLES = {
    'BURUNOV_FIREPLACE': [
        {id: 'burunov_ex1', url: 'https://storage.yandexcloud.net/selebrus-page-assets/burunov.mp4', label: 'Бурунов'},
    ],
    'PUTIN_BEREZKI': [
        {id: 'putin_ex1', url: 'https://storage.yandexcloud.net/selebrus-page-assets/putin.mp4', label: 'Путин'},
    ],
    'EANDREEVA': [
        {
            id: 'andreeva_ex1',
            url: 'https://storage.yandexcloud.net/selebrus-page-assets/andreeva.mp4',
            label: 'Андреева'
        },
    ],
    'URGANT': [
        {
            id: 'urgant_ex1',
            url: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/urgant.mp4',
            label: 'Ургант'
        },
    ],
    'MALAHOV': [
        {id: 'malahov_ex1', url: 'https://storage.yandexcloud.net/selebrus-page-assets/malahov.mp4', label: 'Малахов'},
    ],
    'KIRKOROV': [
        {
            id: 'kirkorov_ex1',
            url: 'https://storage.yandexcloud.net/selebrus-page-assets/kirkorov.mp4',
            label: 'Киркоров'
        },
    ],
    'DMITRIENKO': [
        {
            id: 'dmitrienko_ex1',
            url: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/dmitrienko.mp4',
            label: 'Дмитриенко'
        },
    ],
    'HARLAMOV': [
        {
            id: 'harlamov_ex1',
            url: 'https://storage.yandexcloud.net/selebrus-page-assets/harlamov.mp4',
            label: 'Харламов'
        },
    ],
    'TRUMP': [
        {id: 'trump_ex1', url: 'https://storage.yandexcloud.net/selebrus-page-assets/trump.mp4', label: 'Трамп'},
    ],
    'ELON': [
        {id: 'elon_ex1', url: 'https://storage.yandexcloud.net/selebrus-page-assets/elon.mp4', label: 'Илон'},
    ],
};

export const getExamplesForPersona = (personaId) => VIDEO_EXAMPLES[personaId] || [];
